import { createSlice } from "@reduxjs/toolkit";
import { selectRootUndoRedo } from "views/logic/slices/undoRedoSelectors";
const REVISIONS_MAX_SIZE = 10;
const undoRedoSlice = createSlice({
  name: "undoRedo",
  initialState: {
    revisions: [],
    currentRevision: 0
  },
  reducers: {
    setRevisions: (state, action) => ({
      ...state,
      revisions: action.payload.revisions,
      currentRevision: action.payload.currentRevision
    }),
    setCurrentRevision: (state, action) => ({
      ...state,
      currentRevision: action.payload
    })
  }
});
export const undoRedoSliceReducer = undoRedoSlice.reducer;
export const { setRevisions, setCurrentRevision } = undoRedoSlice.actions;
export const pushIntoRevisions = (revisionItem, setAsLastRevision = true) => async (dispatch, getState) => {
  const { revisions, currentRevision } = selectRootUndoRedo(getState());
  const isLast = currentRevision === revisions.length;
  const cutRevisions = isLast ? revisions : revisions.slice(0, currentRevision);
  const newRevisions = cutRevisions.length < REVISIONS_MAX_SIZE ? [...cutRevisions, revisionItem] : [...cutRevisions.slice(1), revisionItem];
  const newRevision = setAsLastRevision ? newRevisions.length : currentRevision;
  dispatch(setRevisions({ revisions: newRevisions, currentRevision: newRevision }));
};
